'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';

interface StickyDownloadCTAProps {
  onOpenModal: () => void;
}

export default function StickyDownloadCTA({ onOpenModal }: StickyDownloadCTAProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);

      if (
        window.scrollY / (document.body.scrollHeight - window.innerHeight) > 0.5 &&
        typeof window !== 'undefined' &&
        (window as any).__scroll50Tracked !== true
      ) {
        (window as any).__scroll50Tracked = true;
        if ((window as any).gtag) {
          (window as any).gtag('event', 'scroll_50');
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`sticky-cta fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/90 backdrop-blur-xl border-t border-gray-100 px-4 py-3 ${visible ? 'visible' : ''}`}
    >
      <div className="flex items-center gap-3 max-w-sm mx-auto">
        <div className="flex-1">
          <p className="text-xs font-bold text-foreground">Be First to Launch</p>
          <p className="text-[10px] text-muted">Join the Summons waitlist today</p>
        </div>
        <Link
          href="/waitlist"
          className="flex-shrink-0 bg-primary text-white px-5 py-2.5 rounded-xl text-sm font-bold"
        >
          Join Waitlist
        </Link>
      </div>
    </div>
  );
}